module.exports = __webpack_public_path__ + "img/visit-filled.91d56417.svg";